import { observer } from 'mobx-react-lite';
import { useViewSettingsStore } from '..';

function MobileFlag({ children }: IMobileFlagProps) {
    const viewSettingsStore = useViewSettingsStore();
    
    return (
        <div data-mobile={viewSettingsStore.isMobile || undefined}>
            {children}
        </div>
    );
}

export default observer(MobileFlag);

interface IMobileFlagProps {
    children: React.ReactNode;
}
